import { Button, DialogActions, DialogTitle } from "@mui/material";
import GTextField from "../../libs/textfield/GTextField";
import { useRef } from "react";
import FormGroup from "../../libs/form/FormGroup";
import FormControl from "../../libs/form/FormControl";
import Validators from "../../libs/form/Validators";
import PassApi from "../../data/PassApi";
import { useDialog } from "../../libs/dialog/DialogProvider";
import { useSnackbar } from "../../libs/dialog/SnackbarProvider";

export default function ChangePassword(){
    const {closeDialog} = useDialog()
    const {setSnackbar} = useSnackbar()
    const oldPassword = useRef<any>("")
    const newPassword = useRef<any>("")
    const confirm = useRef<any>("")
    
    const MatchValidator = () => {
        if (!confirm.current.value) return "Confirm is required"
        else if (confirm.current.value==newPassword.current.value) return null
        else return "Password mismatch"
    }
    const form = new FormGroup("change", [
        new FormControl("Old password", [Validators.Required], oldPassword.current?.value || ""),
        new FormControl("New password", [Validators.Required], newPassword.current?.value || ""),
        new FormControl("Confirm", [MatchValidator], confirm.current?.value || ""),
    ])
    const checkMatch = () => form.control("Confirm").revalidate()
    const onCreate = async () => {
        if (!form.dirty) form.markAllAsDirty()
        if (!form.valid) return

        try {
            await PassApi.i.updatePassword(oldPassword.current.value, newPassword.current.value)
            closeDialog()
        }catch(e){
            setSnackbar(e)
        }
    }
    return <>
        <DialogTitle>Change Password</DialogTitle>
        <div className="content">
            <GTextField placeholder="Current Password" inputRef={oldPassword} form={form} controlName="Old password" type="password" floatLabel="Current Password" autoComplete="off"/>
            <GTextField placeholder="New Password" inputRef={newPassword} form={form} onChange={checkMatch} controlName="New password" type="password" floatLabel="New Password" autoComplete="new-password"/>
            <GTextField placeholder="Confirm" inputRef={confirm} form={form} controlName="Confirm" type="password" floatLabel="Confirm" autoComplete="new-password"/>
        </div>
        <DialogActions>
            <Button color="primary" onClick={onCreate}>Update</Button>
        </DialogActions>
    </>
}